module.exports = __webpack_public_path__ + "static/media/cellfinate_imagen_diagnostico.d5e92fed.jpg";